module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_3_3.9d71e151.jpeg";